<div class="dashboard-export">
    <h3 class="dashboard-export__title">{{ "projects.dashboard" | translate }}</h3>

    <!-- Project banner -->
    <div class="project-banner">
        <div class="project-banner__main">
            <small class="project-banner__label">{{ "projects.project" | translate }}</small>
            <h4 class="project-banner__name">{{ project.title }}</h4>
            <span [ngClass]="getStatusClass()" class="project-banner__status">
                <i class="pi pi-circle-fill"></i> {{ getStatusKey() | translate }}
            </span>
            <div *ngIf="hasDescription()" class="project-banner__desc" [innerHTML]="project.description"></div>
            <ul *ngIf="project.projectDocuments?.length" class="project-banner__docs">
                <li *ngFor="let doc of project.projectDocuments">
                    <a href="#" (click)="openDocument(doc.id, doc.filename); $event.preventDefault()">
                        <i class="pi pi-paperclip"></i> {{ doc.filename }}
                    </a>
                </li>
            </ul>
        </div>
        <div class="project-banner__meta">
            <div *ngIf="nextDeadline" class="project-banner__deadline">
                <small class="project-banner__deadline-label">{{ "projects.dashboardUi.nextDeadline" | translate }}</small>
                <div class="project-banner__deadline-row">
                    <i class="pi pi-calendar"></i>
                    <span class="project-banner__deadline-value">{{ nextDeadline.date | date: 'dd/MM/yyyy' }}</span>
                </div>
            </div>
        </div>
    </div>

    <!-- KPI cards -->
    <div class="kpi-grid">
        <div class="kpi-card">
            <div class="kpi-card__icon kpi-card__icon--products"><i class="pi pi-box"></i></div>
            <div class="kpi-card__body">
                <span class="kpi-card__label">{{ "projects.dashboardUi.kpi.products" | translate }}</span>
                <span class="kpi-card__value">{{ totalProducts }}</span>
                <span class="kpi-card__sub">{{ "general.products" | translate }}</span>
            </div>
        </div>
        <div class="kpi-card">
            <div class="kpi-card__icon kpi-card__icon--exports"><i class="pi pi-cloud-upload"></i></div>
            <div class="kpi-card__body">
                <span class="kpi-card__label">{{ "projects.dashboardUi.kpi.exports" | translate }}</span>
                <span class="kpi-card__value">{{ exportCount }}</span>
                <span class="kpi-card__sub">{{ "projects.dashboardUi.kpi.exportsSub" | translate }}</span>
            </div>
        </div>
        <div class="kpi-card">
            <div class="kpi-card__icon kpi-card__icon--pages"><i class="pi pi-file"></i></div>
            <div class="kpi-card__body">
                <span class="kpi-card__label">{{ "projects.export.progress.page" | translate }}</span>
                <span class="kpi-card__value">{{ totalPages }}</span>
                <span class="kpi-card__sub">{{ "projects.dashboardUi.kpi.pagesSub" | translate }}</span>
            </div>
        </div>
    </div>

    <!-- Exports summary -->
    <div class="exports-summary">
        <div class="exports-summary__header">
            <h5 class="exports-summary__title">{{ "projects.dashboardUi.summary" | translate }}</h5>
            <div class="exports-summary__actions">
                <ng-container *ngTemplateOutlet="exportButtons"></ng-container>
                <button *ngIf="_selectedRows.length" id="cart" class="dash-btn dash-btn--selection position-relative" data-toggle="modal" data-target="#cartModal">
                    <i class="pi pi-shopping-cart"></i>
                    {{ "datatable.selection" | translate }}
                    <span class="dash-btn__count">{{ _selectedRows.length }}</span>
                </button>
            </div>
        </div>

        <div *ngIf="!exports || exports.length === 0" class="exports-summary__empty">
            {{ 'general.no.result' | translate }}
        </div>

        <p-table *ngIf="exports?.length" [value]="exports" [(selection)]="_selectedRows" dataKey="name" styleClass="exports-table" [paginator]="exports.length > 10" [rows]="10" [rowsPerPageOptions]="[10, 25, 50]">
            <ng-template pTemplate="header">
                <tr>
                    <th style="width: 3rem">
                        <p-tableHeaderCheckbox></p-tableHeaderCheckbox>
                    </th>
                    <th>{{ "table.name" | translate }}</th>
                    <th>{{ "table.workflow" | translate }}</th>
                    <th class="text-center">{{ "general.products" | translate }}</th>
                    <th class="text-center">{{ "table.groups" | translate }}</th>
                    <th class="text-center">{{ "table.element" | translate }}</th>
                    <th class="text-right" style="width: 230px;">{{ "table.actions" | translate }}</th>
                </tr>
            </ng-template>
            <ng-template pTemplate="body" let-projectExport>
                <tr>
                    <td>
                        <p-tableCheckbox [value]="projectExport"></p-tableCheckbox>
                    </td>
                    <td [attr.data-label]="'table.name' | translate">
                        <span *ngIf="projectExport.versionId" class="version-marker">└ {{ 'version.new' | translate }} :</span>
                        <span class="export-name">{{ projectExport.name }}</span>
                    </td>
                    <td [attr.data-label]="'table.workflow' | translate">
                        <ng-container *ngIf="getStepProgress(projectExport) !== null; else noStep">
                            <div class="step-cell">
                                <span *ngIf="getExportStep(projectExport)" class="step-cell__badge">{{ getExportStep(projectExport) }}</span>
                                <div class="step-cell__bar-row">
                                    <div class="step-cell__bar">
                                        <div class="step-cell__fill" [style.width.%]="getStepProgress(projectExport)"></div>
                                    </div>
                                    <span class="step-cell__pct">{{ getStepProgress(projectExport) }}%</span>
                                </div>
                            </div>
                        </ng-container>
                        <ng-template #noStep><span class="text-muted">—</span></ng-template>
                    </td>
                    <td class="text-center" [attr.data-label]="'general.products' | translate">
                        <span class="products-count">{{ projectExport.elementLength }}</span>
                    </td>
                    <td class="text-center" [attr.data-label]="'table.groups' | translate">
                        <span *ngFor="let groupName of projectExport.groupNames;" class="group-badge">{{ groupName }}</span>
                        <span *ngIf="!projectExport.groupNames?.length" class="text-muted">—</span>
                    </td>
                    <td class="text-center" [attr.data-label]="'table.element' | translate">
                        <div class="type-cell">
                            <span [ngClass]="getIconClass(projectExport.type)" class="type-cell__icon"></span>
                            <span class="type-cell__label">{{ projectExport.type }}</span>
                        </div>
                    </td>
                    <td class="text-right" [attr.data-label]="'table.actions' | translate">
                        <div class="action-cell">
                            <button *ngIf="projectExport.type === 'CSV' || projectExport.type === 'EXCEL'" (click)="onActionClick(projectExport, false)" type="button" class="btn btn-sm btn-outline-primary" data-toggle='modal' data-target='#csvModal'>
                                <fa-icon [icon]="faEye" [fixedWidth]="true"></fa-icon>
                                <span *ngIf="projectExport.type === 'CSV'">{{ 'general.showCSV' | translate }}</span>
                                <span *ngIf="projectExport.type === 'EXCEL'">{{ 'general.showExcel' | translate }}</span>
                            </button>
                            <button *ngIf="canEdit(projectExport)" (click)="onActionClick(projectExport)" type="button" class="btn btn-sm btn-outline-primary">
                                <div *ngIf="projectExport.type !== 'CSV' && projectExport.type !== 'JSON' && projectExport.type !== 'XML' && projectExport.type !== 'EXCEL'; then thenBtnWorkBlock else elseBtnDownloadBlock"></div>
                                <ng-template #thenBtnWorkBlock><fa-icon [icon]="faEdit" [fixedWidth]="true"></fa-icon> {{ 'projects.work' | translate }}</ng-template>
                                <ng-template #elseBtnDownloadBlock><fa-icon [icon]="faDownload" [fixedWidth]="true"></fa-icon> {{ 'general.download' | translate }}</ng-template>
                            </button>
                            <ng-container *ngIf="projectExport.type !== 'CSV' && projectExport.type !== 'JSON' && projectExport.type !== 'XML' && projectExport.type !== 'EXCEL'">
                                <button *ngIf="!projectExport.versionId && canCreateVersion()" class="btn btn-sm btn-outline-info" (click)="onNewVersion(projectExport.id)">
                                    <i class="far fa-copy"></i> {{'version.new' | translate}}
                                </button>
                                <button *ngIf="projectExport.versionId && canCreateVersion()" class="btn btn-sm btn-outline-info" (click)="onUpdateVersion(projectExport.id, projectExport.versionId)">
                                    <i class="far fa-copy"></i> {{'version.update' | translate}}
                                </button>
                                <button *ngIf="projectExport.versionId && canCreateVersion()" class="btn btn-sm btn-outline-danger" (click)="onDeleteVersion(projectExport.versionId)">
                                    <i class="far fa-trash-alt"></i> {{'version.delete' | translate}}
                                </button>
                            </ng-container>
                        </div>
                    </td>
                </tr>
            </ng-template>
        </p-table>
    </div>
</div>
<swal #versionSwal title="{{ 'version.new' | translate }}" [showConfirmButton]="true" confirmButtonText="{{ 'general.save' | translate}}" [showCloseButton]="true">
    <form *swalPortal [formGroup]="newVersion">
        <div class="form-group">
            <div *ngIf="newVersion.controls.duplicatePages" class="form-group row">
                <label for="active" class="col-sm-4 col-form-label">{{ 'projects.flatplan.duplicatePages' | translate }}</label>
                <div class="col-sm-8">
                    <label class="switch switch-label switch-primary">
                        <input id="active" class="switch-input" type="checkbox" formControlName="duplicatePages"/>
                        <span class="switch-slider" data-checked="✓" data-unchecked="✕"></span>
                    </label>
                </div>
            </div>
            <div class="form-group row">
                <label for="name" class="col-sm-4 col-form-label">
                    {{'table.name' | translate}} :
                </label>
                <div class="col-sm-8">
                    <input class="form-control" type="text" formControlName="name" />
                </div>
            </div>
            <div class="form-group row">
                <label for="groups" class="col-sm-4 col-form-label">
                    {{'table.groups' | translate}} :
                </label>
                <div class="col-sm-8">
                    <p-multiSelect (onChange)="getUsers($event)" formControlName="groups" [options]="groups" optionLabel="name" optionValue="id" [selectionLimit]="1" defaultLabel="{{ (groups.length ? 'admin.groups.selectOwner' : 'admin.groups.noGroup') | translate }}" [style]="{'width':'100%'}"></p-multiSelect>
                </div>
            </div>

            <nav *ngIf="newVersion.controls.steps" >
                <div class="nav nav-tabs" id="nav-steps-tabs" role="tablist">
                    <a *ngFor="let step of newVersion.controls.steps['controls']; let i = index" [ngClass]="{ 'nav-item nav-link': true, active: i === 0 }" id="nav-etape-{{ i }}-tab" data-toggle="tab" href="#nav-etape-{{ i }}" role="tab" [attr.aria-controls]="'nav-etape-' + i" [attr.aria-selected]="i === 0 ? 'true' : 'false'">
                        {{ step.get('name').value }}
                    </a>
                </div>
            </nav>

            <div *ngIf="newVersion.controls.steps" class="tab-content" id="nav-places-content">
                <div *ngFor="let step of newVersion.controls.steps['controls']; let i = index" [ngClass]="{ 'tab-pane fade': true, 'show active': i === 0 }" id="nav-etape-{{ i }}" role="tabpanel" [attr.aria-labelledby]="'nav-etape-' + i + '-tab'" >
                    <div  formArrayName="steps">
                        <div [formGroupName]="i">
                            <div class="form-group row">
                                <label class="col-sm-2 col-form-label">
                                    {{ 'projects.conf.due_date' | translate }}
                                </label>
                                <div class="col-sm-10">
                                    <app-date-picker  [active]="true" formControlName="dateFin"></app-date-picker>
                                </div>
                            </div>
                            <div class="form-group row">
                                <label for="groups" class="col-sm-4 col-form-label">
                                    {{'admin.workflow.users' | translate}} :
                                </label>
                                <div class="col-sm-8">
                                    <p-multiSelect formControlName="users" [options]="users" optionLabel="name" optionValue="id" [style]="{'width':'100%'}"></p-multiSelect>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </form>
</swal>

<!-- Modal for CSV -->
<div class="modal fade" id="csvModal" tabindex="-1" role="dialog" aria-labelledby="csvModal" aria-hidden="true">
    <div class="modal-dialog modal-xl" role="csvModal">
        <div class="modal-content">
            <div class="modal-header">
                <h5 class="modal-title">{{ 'general.feedAgregator' | translate}}</h5>
                <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                    <span aria-hidden="true">&times;</span>
                </button>
            </div>
            <div class="modal-body csv-modal-body">
                <table class="myTable tableFixHead">
                    <thead>
                    <tr>
                        <th *ngFor="let header of csvHeaders;">
                            <span>{{ hideQuotes(header) }}</span>
                        </th>
                    </tr>
                    </thead>
                    <tbody>
                    <tr *ngFor="let row of csvRows;">
                        <td #td (click)="removeTruncation(td)" *ngFor="let cell of row;">
                            <span *ngIf="cell.length > 0">{{ hideQuotes(cell) }}</span>
                            <span *ngIf="cell.length == 0">{{ cell }}</span>
                        </td>
                    </tr>
                    </tbody>
                </table>
            </div>
            <div class="modal-footer">
                <button (click)="downloadFlux()" class="btn btn-primary">{{ 'general.download' | translate }}</button>
            </div>
        </div>
    </div>
</div>
<!-- END Modal for CSV -->

<!-- Template Mass Buttons Local -->
<ng-template #exportButtons>
    <div class="dash-toolbar" *ngIf="_selectedRows.length">
        <button type="button"
            (click)="getIdsForArchive()"
            class="dash-btn dash-btn--primary"><i class="pi pi-download"></i><span>{{
                'projects.export.generation.downloadArchive' | translate }} {{ 'projects.export.generation.archiveBd' | translate }}</span></button>
        <button type="button"
        (click)="getIdsForArchive(true)"
        class="dash-btn dash-btn--primary"><i class="pi pi-download"></i><span>{{
            'projects.export.generation.downloadArchive' | translate }} {{ 'projects.export.generation.archiveHd' | translate }}</span></button>
    </div>
</ng-template>

<!-- Selection Modal Local -->
<div class="modal fade" id="cartModal" tabindex="-1" role="dialog" aria-labelledby="cartModalLabel" aria-hidden="true">
    <div class="modal-dialog modal-lg" role="document">
        <div class="modal-content">
            <div class="modal-header">
                <h5 class="modal-title" id="cartModalLabel">{{ "datatable.selection" | translate }} : {{
                    _selectedRows.length }} {{ 'projects.project' | translate }}(s)</h5>
                <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                    <span aria-hidden="true">&times;</span>
                </button>
            </div>
            <div class="modal-body">
                <ul class="list-unstyled">
                    <div *ngIf="_selectedRows.length">
                        <li *ngFor="let row of _selectedRows" class="pb-2 pt-2">
                            <div class="row">
                                <div class="col-8 text-truncate mt-3">
                                    <span class="font-weight-bold">{{ row.name }} </span>
                                </div>
                                <div class="col-4 mt-2 text-right">
                                    <button (click)="removeFromSelection(row.name)" class="ml-auto btn btn-sm-danger">
                                        <i class="pi pi-minus-circle"></i>
                                    </button>
                                </div>
                            </div>
                        </li>
                    </div>
                    <div *ngIf="!_selectedRows.length">
                        {{ "datatable.emptySelection" | translate }}
                    </div>
                </ul>
            </div>
            <div class="modal-footer">
                <ng-container *ngTemplateOutlet="exportButtons"></ng-container>
            </div>
        </div>
    </div>
</div>
